module.exports = __webpack_public_path__ + "img/menu-sj.44e939c3.png";